export const sv = {
  general: {
    add: "Lägg till",
    admin: "Admin",
    age: "Ålder",
    ago: "sedan",
    alarm: "Alarm",
    alarmNotification: "OBS! Det finns ärenden med alarm",
    appTitle: "Kundportal",
    assistanceNote: "Assistansnotering",
    assetObjectId: "Objekt",
    back: "Tillbaka",
    cancel: "Avbryt",
    category: "Kategori",
    close: "Stäng",
    completed: "Avslutat",
    confirm: "Bekräfta",
    create: "Skapa",
    created: "Skapad",
    createExample: "Skapa exempel",
    createWorkOrder: "Skapa ärende",
    client: "Kund",
    date: "Datum",
    delete: "Ta bort",
    edit: "Redigera",
    email: "Email",
    export: "Exportera",
    externalId: "Externt ID",
    facility: "Anläggning",
    minutesShort: "min",
    hasNoLoginAccess: "saknar behörighet till denna app",
    holiday: "Helgdag",
    id: "Id",
    information: "Information",
    lastContactAt: "Senaste kontakt",
    list: "Lista",
    login: "Logga in",
    loginFailed: "Inloggningen misslyckades",
    loginText: "Logga in med dina uppgifter",
    loginWithMicrosoft: "Logga in med Microsoft",
    logout: "Logga ut",
    name: "Namn",
    no: "Nej",
    note: "Notering",
    password: "Lösenord",
    phone: "Telefon",
    phoneNumber: "Telefonnummer",
    resource: "Resurs",
    resources: "Resurser",
    role: "Roll",
    save: "Spara",
    subject: "Ämne",
    tmpNote: "Tmp notering",
    type: "Typ",
    update: "Uppdatera",
    updated: "Uppdaterad",
    username: "Användarnamn",
    welcomeText: "ONE Nordic Kundportal",
    workOrders: "Ärenden",
    yes: "Ja",
  },
  userStatus: {
    ACTIVE: "Aktiv",
    INACTIVE: "Inaktiv",
    INVITED: "Inbjuden",
    PENDING_INVITE: "Väntar på svar",
  },
} as const;
